<template>
  <v-text-field
    v-bind="{ ...$attrs, ...$props }"
    class="menu-search text-body-1"
    height="52px"
    dense
    solo
    flat
    hide-details
    v-on="$listeners"
  >
    <template #prepend-inner>
      <v-icon>ui-icon-search</v-icon>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'MenuSearch',
}
</script>

<style lang="scss">
@import '~www/themes/doctors/common/variables';

.menu-search {
  .v-input__slot {
    input {
      color: $ui-kit-text;
      font-weight: $weight-regular;
      font-size: 16px;
      line-height: 125%;
    }

    .v-input__prepend-inner {
      color: $ui-kit-text-secondary;
      padding: 0 8px 0 0;
    }
  }
}
</style>
